import { FC, useEffect, useRef } from "react";
import { selectChatMessages } from "@/store/features/chat/selectors";
import { useAppSelector } from "@/store/hooks";
import ChatMessage from "../ChatMessage";
import { StyledChatContent } from "./styled";

const ChatContent: FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  const messages = useAppSelector(selectChatMessages);

  useEffect(() => {
    if (messages.length) {
      containerRef.current?.scrollTo({
        top: containerRef.current?.scrollHeight,
        behavior: 'smooth',
      });
    }
  }, [messages.length]);

  return (
    <StyledChatContent ref={containerRef}>
      {messages.map((message, index, arr) => (
        <ChatMessage
          key={message.id}
          name={message.name}
          message={message.text}
          date={message.date}
          isLast={index === arr.length - 1}
        />
      ))}
    </StyledChatContent>
  );
};

export default ChatContent;